import ModelFilter from './ModelFilter'

const Filters = {
  'Model': ModelFilter,
  'Text': 'agTextColumnFilter',
  'Number': 'agNumberColumnFilter'
}

export default Filters
